<template>
  <div class="groupingManagement-page">
    <div class="all-content-container">
      <div class="table-container">
        <div class="table-title-container">
          <el-button v-allow="'080101'" type="primary" @click="handleAdd">添加</el-button>
        </div>
        <div class="table-content-container">
          <el-table :data="tableData" style="width: 100%; margin-bottom: 20px" row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :header-cell-style="{ background: '#f4f5f7' }">
            <el-table-column prop="name" label="分组名称" align="center"></el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" class="marginLr" @click="handleEdit(scope.row.id)" v-allow="'080102'">编辑</el-link>
                <el-link type="primary" :underline="false" class="marginLr" @click="handleDel(scope.row.id)" v-allow="'080103'">删除</el-link>
              </template>
            </el-table-column>
          </el-table>

          <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" :before-close="handleCancel" width="800px" center style="z-index: 10000">
            <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-row>
                <el-col :span="24">
                  <el-form-item v-if="ruleForm.parentId !==0" label="上级分组：">
                    <el-cascader @change="changeTreeItem" :show-all-levels="false" v-model="ruleForm.parentId" :options="parentGroupArray" :props="optionProps" clearable placeholder="请选择上级分组"></el-cascader>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                  <el-form-item label="分组图片：" prop="image">
                    <UploadImg para="image" @setImg="setImg" :imgUrl="ruleForm.image" width="150" height="100"></UploadImg>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="排序号：">
                    <el-input v-model="ruleForm.orderNum" placeholder="请输入排序号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="分组名称：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入分组名称" maxlength="20" show-word-limit clearable></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                  <el-form-item label="分组编码：" prop="groupCode">
                    <el-input maxlength="20" show-word-limit clearable v-model="ruleForm.groupCode" placeholder="请输入分组编码"></el-input>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <!-- <el-row v-if="ruleForm.level == 3">
                <el-col :span="24">
                  <el-form-item label="分组类型：" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择分组类型" clearable>
                      <el-option label="无" value="0"></el-option>
                      <el-option label="数字大棚" value="1"></el-option>
                      <el-option label="数字大田" value="2"></el-option>
                      <el-option label="数字渔场" value="3"></el-option>
                      <el-option label="数字园林" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row v-if="ruleForm.level == 2">
                <el-col :span="12">
                  <el-form-item label="分组类型：" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择分组类型" clearable>
                      <el-option label="数字大棚" value="1"></el-option>
                      <el-option label="数字大田" value="2"></el-option>
                      <el-option label="数字渔场" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="分组模型：" prop="groupModelId">
                    <el-select v-model="ruleForm.groupModelId" placeholder="请选择分组模型" clearable>
                      <el-option v-for="(item, index) in groupModelArray" :label="item.name" :value="item.id" :key="index">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row>
                <el-col :span="12">
                  <el-form-item label="分组种类：" prop="groupClass">
                    <el-input maxlength="50" show-word-limit clearable v-model="ruleForm.groupClass" placeholder="请输入分组种类"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="主养作物：" prop="mainCrop">
                    <el-input maxlength="50" show-word-limit clearable v-model="ruleForm.mainCrop" placeholder="请输入主养作物"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row>
                <el-col :span="12">
                  <el-form-item label="分组面积：" prop="area">
                    <el-input-number placeholder="请输入分组面积（亩）" v-model="ruleForm.area" :precision="2" :step="1" :min="0" :max="9999999" size="small" clearable></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="分组深度：" prop="groupDepth">
                    <el-input-number placeholder="请输入分组深度（米）" v-model="ruleForm.groupDepth" :precision="2" :step="1" :min="0" :max="9999999" size="small" clearable></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="经度：" prop="longitude">
                    <el-input-number placeholder="请输入经度" v-model="ruleForm.longitude" :precision="6" :step="1" :min="-9999999" :max="9999999" size="small" clearable></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="纬度：" prop="dimension">
                    <el-input-number placeholder="请输入纬度" v-model="ruleForm.dimension" :precision="6" :step="1" :min="-9999999" :max="9999999" size="small" clearable></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row>
                <el-col :span="24">
                  <el-form-item label="详细地址：" prop="address">
                    <el-input maxlength="100" show-word-limit clearable v-model="ruleForm.address" placeholder="请输入详细地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="24">
                  <el-form-item label="分组描述：" prop="remark">
                    <el-input maxlength="50" show-word-limit clearable v-model="ruleForm.remark" placeholder="请输入分组描述"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="分组状态：" prop="groupStatus">
                    <el-select v-model="ruleForm.groupStatus" placeholder="请选择分组状态" clearable>
                      <el-option label="待产中" :value="0"></el-option>
                      <el-option label="生产中" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <el-row>
                <el-col :span="24">
                  <el-form-item label="分组类型：" prop="homeGroupType">
                    <el-select v-model="ruleForm.homeGroupType" placeholder="请选择分组类型" clearable>
                      <el-option label="种植柜" :value="0"></el-option>
                      <el-option label="水培架" :value="1"></el-option>
                      <el-option label="温室" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="所在城市：">
                    <el-cascader v-model="ruleForm.areaArr" placeholder="请选择所在城市" :options="areaData" ref="cascaderAddr" :props="{ value: 'label', label: 'label' }" clearable @change="areaChange">
                    </el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="24">
                  <el-form-item label="城市编码：">
                    <el-input v-model="ruleForm.addressCode" placeholder="请输入城市编码" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->

            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleCancel">取 消</el-button>
              <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadImg from '@/components/upload/UploadImg.vue'
import { regionData } from 'element-china-area-data'

export default {
  components: { UploadImg },
  data() {
    return {
      editId: '',
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      centerDialogVisible: false,
      dialogTitle: '',
      total: 0,
      ruleForm: {
        id: '',
        parentId: '', //上级分组id
        level: '',
        groupCode: '', //分组编号
        name: '', //分组名称
        dimension: undefined,
        longitude: undefined,
        type: '0',
        image: '',
        area: '',
        groupDepth: '',
        groupClass: '',
        groupModelId: '',
        address: '',
        mainCrop: '',
        groupStatus: '',
        code: '',
        areaArr: [],
        addressCode: '',
        addressDivide: '',
        orderNum: '',
        homeGroupType: '',
        positionNum: 1
      },
      rules: {
        groupCode: [{ required: true, message: '请输入分组编号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入分组名称', trigger: 'blur' }]
      },
      tableData: [],
      pagesize: 8,
      currentPage: 1,
      parentGroupArray: [], // 上级分组（1、2级分组）
      id: '0', //查询设备分组树，查询1(id 为1)
      groupModelArray: [], // 分组类型数组
      areaData: regionData
    }
  },
  created() {
    // 获取列表
    this.getList()

    // 获取分组模型列表
    this.getConfigGroupModels()
  },
  // 函数集合
  methods: {
    // 获取列表
    getList() {
      this.$api.system
        .getConfigGroupTree(
          this.id //主键id ，根据具体业务进行判定
        )
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data
            this.total = res.count
          }
        })
    },
    // 删除
    handleDel(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.$api.system.delfun(`/pc/configGroup/delConfigGroup`, id).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getList()
          }
        })
      })
    },
    // 城市下拉切换
    areaChange() {
      this.ruleForm.area = ''

      this.ruleForm.dimension = ''
      this.ruleForm.longitude = ''
      console.log(this.ruleForm, 233)
      if (this.ruleForm.areaArr.length == 3) {
        let name = this.ruleForm.areaArr[2]
        if (name == '市辖区') {
          name = this.ruleForm.areaArr[1]
        }
        this.ruleForm.addressDivide = this.ruleForm.areaArr.join(' / ')
        this.$api.growthModel.getCity({ name: name }).then((res) => {
          if (res.code == 200 && res.data.length > 0) {
            this.ruleForm.addressCode = res.data[0].code
          } else {
            this.$message({
              type: 'error',
              message: '该城市数据不全，请更换城市'
            })
            this.ruleForm.areaArr = []
          }
        })
      }
    },
    //添加
    handleAdd() {
      this.dialogTitle = '添加分组'
      this.ruleForm.id = ''
      this.ruleForm.type = '0'
      this.centerDialogVisible = true

      // 查询一级和二级分组
      this.getConfigGroupOneAndTwo()
    },
    // 编辑
    handleEdit(id) {
      this.dialogTitle = '编辑分组'
      this.ruleForm.id = id
      this.centerDialogVisible = true

      // 获取详情
      this.getDetail(id)
      // 查询一级和二级分组
      this.getConfigGroupOneAndTwo()
    },
    // 获取详情
    getDetail(id) {
      this.$api.system.getConfigGroup({ id: id }).then((res) => {
        if (res.code == 200) {
          res.data.areaArr = res.data.addressDivide != undefined ? res.data.addressDivide.split(' / ') : []
          this.ruleForm = res.data
          this.ruleForm.type = res.data.type.toString()
        }
      })
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.centerDialogVisible = false
      this.ruleForm = {
        groupCode: '', //分组编号
        name: '', //分组名称
        parentId: '', //上级分组id
        dimension: undefined,
        id: '',
        level: '',
        longitude: undefined,
        type: '0',
        image: '',
        area: '',
        groupDepth: '',
        groupClass: '',
        groupModelId: ''
      }
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.ruleForm.parentId = this.ruleForm.parentId ? this.ruleForm.parentId : '0'
          this.$api.system.saveConfigGroup(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({ type: 'success', message: res.msg })
              this.handleCancel()
              this.getList()
            }
          })
        }
      })
    },
    // 查询一级和二级分组
    getConfigGroupOneAndTwo() {
      this.$api.system.getConfigGroupOneAndTwo({}).then((res) => {
        if (res.code == 200) {
          this.parentGroupArray = res.data
        }
      })
    },
    // 上级分组下拉切换
    changeTreeItem(val) {
      this.ruleForm.level = val.length + 1
      if (this.ruleForm.level == 1) {
        // 1级分组时，分组类型强制为0无
        this.ruleForm.type = '0'
      } else {
        this.ruleForm.type = ''
      }

      if (val) {
        this.ruleForm.parentId = val[val.length - 1]
      } else {
        this.ruleForm.parentId = 0
      }
    },
    // 获取分组模型列表
    getConfigGroupModels() {
      this.$api.system.getConfigGroupModels({}).then((res) => {
        if (res.code == 200) {
          this.groupModelArray = res.data
        }
      })
    },
    // 上传图片
    setImg(url) {
      this.ruleForm.image = url
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/groupingManagement.scss';

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>